import { useEffect, useState } from 'react';

/** Keyed results prevent a previous player's response flashing during navigation. */
export const useRelationshipRequest = <T,>(key: string, load: (signal: AbortSignal) => Promise<T>) => {
  const [result, setResult] = useState<{ key: string; data?: T; error?: Error }>({ key });
  useEffect(() => {
    const controller = new AbortController();
    load(controller.signal).then(
      (data) => { if (!controller.signal.aborted) setResult({ key, data }); },
      (error: unknown) => { if (!controller.signal.aborted) setResult({ key, error: error instanceof Error ? error : new Error('Unable to load relationships.') }); },
    );
    return () => controller.abort();
    // The caller's key describes the entire request, including its snapshot.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return result.key === key ? result : { key };
};
